import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

export interface IsPreviewPanelAvailableCommandProperties extends CommandProperties {
  ari: string;
}

export const IsPreviewPanelAvailableCommand = createCommand<
  IsPreviewPanelAvailableCommandProperties,
  boolean
>('is-preview-panel-available');
